import {
  Col, Row, Form, Input, notification, InputNumber,
  Button, Spin, Select, Drawer, Tag, Tooltip,
} from "antd";
import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import GooglePlacesAutocomplete, { geocodeByAddress } from "react-google-places-autocomplete";
import { CloseOutlined, PlusOutlined } from "@ant-design/icons";
import { withAppContext } from "../../../store/contextStore";
import { update, getDetails, noAuthlist } from "../../../api/Apis";
import Subscriptions from "../../Subscriptions/Subscriptions";
import RichText from "../../../common/RichText";
import BuyerProfileModal from "../../../common/BuyerProfileModal";

const { TextArea } = Input;
const { Option } = Select;

// ── Personality data ──────────────────────────────────────────────────────────
const SPECIALTIES = [
  "Buyer representation","Seller representation","Downsizing","Upsizing",
  "Relocation","Investment properties","Flipping","1031 exchanges","Commercial",
  "Land","New Construction","Builder representation","Waterfront properties",
  "Farm/horse properties","Rentals","First Time Buyers","Short Sales",
  "Business Representation","Over 55/Active Adult","Bank Owned",
];

const CLIENT_TYPES = [
  "First-time buyers","Move-up buyers","Downsizers","Investors",
  "Luxury buyers","Relocation clients","Empty nesters","Military/VA",
  "Self-employed","Divorcing couples","Estate sales","International buyers",
];

const HOBBIES = [
  "🏃 Running","🚴 Cycling","🧘 Yoga","⛳ Golf","🎾 Tennis","🏊 Swimming",
  "🍳 Cooking","🌱 Gardening","📚 Reading","✈️ Travel","🎵 Music","🎨 Art",
  "🐾 Pets","🏔️ Hiking","📸 Photography","⛷️ Skiing","🏂 Snowboarding",
  "🎣 Fishing","⚽ Soccer","🏀 Basketball","⚾ Baseball","🏈 Football",
  "🎯 Hunting","🚣 Kayaking","🏄 Surfing","🎸 Guitar","🍷 Wine & Food",
  "🏋️ Fitness","🧗 Rock Climbing","🎲 Board Games","🎬 Movies",
];

const WHY_VALUES = [
  "Community first","Integrity always","Family-driven","Client advocacy",
  "Education & empowerment","Long-term relationships","Local expertise",
  "Transparency","Innovation","Giving back",
];

const NAVY = "#1A2280";
const GOLD = "#D4921A";
const BORDER = "#E2E8F0";
const MUTED = "#718096";
const BG = "#F7F9FC";

const sectionTitle = {
  fontSize: "16px", fontWeight: 800, color: NAVY,
  borderBottom: `2px solid ${GOLD}`, paddingBottom: "8px",
  marginBottom: "16px", marginTop: "24px",
};

const labelStyle = {
  fontSize: "12px", fontWeight: 700, color: NAVY,
  textTransform: "uppercase", letterSpacing: ".05em",
  display: "block", marginBottom: "4px",
};

const chip = (active) => ({
  display: "inline-block", padding: "5px 12px", borderRadius: "20px",
  fontSize: "12px", cursor: "pointer", margin: "3px",
  fontWeight: active ? 700 : 400,
  background: active ? NAVY : "#fff",
  color: active ? "#fff" : "#1A202C",
  border: `1.5px solid ${active ? NAVY : BORDER}`,
  transition: "all .15s",
});

const formItemLayout = {
  labelCol: { xs: { span: 24 }, sm: { span: 4 } },
  wrapperCol: { xs: { span: 24 }, sm: { span: 20 } },
};

class ProfileForm extends Component {
  constructor(props) {
    super(props);
    const ud = props.userDetails || {};
    const nd = ud.newdata || {};
    const ap = ud.agentPersonality || {};
    const sm = ud.socialMedia || {};

    // Normalize serviceAreas — might be objects or strings
    const rawAreas = nd.serviceAreas || [];
    const serviceAreas = Array.isArray(rawAreas)
      ? rawAreas.map(a => typeof a === "object" ? (a.cityName || a.name || "") : a).filter(Boolean)
      : rawAreas ? [rawAreas] : [];

    this.formRef = React.createRef();
    this.state = {
      // existing fields
      saveDetailsFalse: false,
      dataLoadingFalse: false,
      inviteLinkCopied: false,
      richtTextBiofield: ud.userBio || "",
      allUsersList: [],
      referedById: ud.referedById   || "",
      referedByName: ud.referedByName || "",
      citySearch: [],
      zipCode: "",
      serviceAreas,
      Ziplist: nd.zipCodes || [],
      zip: "",
      showSubscriptions: false,
      optionsSelected: Array.isArray(nd.Specialties) ? nd.Specialties : [],
      // Basic fields as controlled state so hydrateFromUser can update them
      firstName:       ud.firstName              || "",
      lastName:        ud.lastName               || "",
      phone:           ud.phone                  || "",
      mobile:          nd.mobile                 || "",
      titleorPosition: nd.titleorPosition        || "",
      faxNumber:       nd.faxNumber              || "",
      companyName:     nd.companyName            || "",
      whatsapp:        nd.whatsapp               || "",
      mlsId:           ud.mlsId                  || "",
      licenseIds:      nd.licenseIds             || "",
      userState:       nd.userState              || "",
      language:        nd.language               || "",
      website:         nd.website                || "",
      profileUrl:      ud.profileUrl             || "",
      // personality fields
      client_types:   ap.client_types   || [],
      voice_tone:     ap.voice_tone     || "",
      emoji_usage:    ap.emoji_usage    || "",
      opinion_level:  ap.opinion_level  || "",
      cta_style:      ap.cta_style      || "",
      platforms:      ap.platforms      || [],
      posting_freq:   ap.posting_freq   || "",
      post_length:    ap.post_length    || "",
      content_mix:    ap.content_mix    || [],
      hobbies:        ap.hobbies        || [],
      why_values:     ap.why_values     || [],
      family_stage:   ap.family_stage   || "",
      grew_up:        ap.grew_up        || "",
      origin_story:   ap.origin_story   || "",
      fun_fact:       ap.fun_fact       || "",
      local_love:     ap.local_love     || "",
      great_work_day: ap.great_work_day || "",
      brand_word:     ap.brand_word     || "",
      experience:     ap.experience     || "",
      unique_angle:   ap.unique_angle   || "",
      price_range:    ap.price_range    || "",
      // social media
      facebook:   sm.facebook   || "",
      instagram:  sm.instagram  || "",
      linkedin:   sm.Linkedin   || "",
      youtube:    sm.youtube    || "",
      twitter:    sm.twitter    || "",
    };
  }

  componentDidMount() {
    this.getAllUsers();
    this.refreshFromApi();
  }

  // Fetch fresh data from API so profile modal answers show up immediately,
  // even if localStorage was set before the modal ran
  refreshFromApi = async () => {
    // Try all possible sources for the user ID
    const propUD   = this.props.userDetails || {};
    const ctxUD    = this.props.context?.state?.userDetails || {};
    const lsUD     = (() => { try { return JSON.parse(localStorage.getItem('userDetails') || '{}'); } catch(e) { return {}; } })();
    const ctxUser  = this.props.context?.state?.user || {};

    const uid = propUD.id     || ctxUD.id
              || lsUD.id
              || propUD.userid || ctxUD.userid
              || ctxUser.userid
              || lsUD.userid;

    const userDetails = ctxUD.id ? ctxUD : lsUD.id ? lsUD : propUD;



    if (!uid) {
      console.warn('ProfileForm: no uid found');
      return;
    }
    try {
      const fresh = await getDetails('users', uid);


      const u = fresh?.data?.id ? fresh.data
              : fresh?.id       ? fresh
              : fresh?.success && fresh?.data ? fresh.data
              : null;


      if (u) {
        localStorage.setItem('userDetails', JSON.stringify(u));
        this.props.context.setUserDetails(u);
        this.hydrateFromUser(u);
  
      } else {
        console.warn('ProfileForm: using props fallback');
        this.hydrateFromUser(userDetails);
      }
    } catch (e) {
      console.warn('ProfileForm: API refresh failed:', e.message);
      this.hydrateFromUser(userDetails);
    }
  };

  // Single source of truth for hydrating all form state from a user record
  hydrateFromUser = (u) => {
    if (!u) return;
    const nd = u.newdata || {};
    const ap = u.agentPersonality || {};
    const sm = u.socialMedia || {};
    const rawAreas = nd.serviceAreas || [];
    const serviceAreas = Array.isArray(rawAreas)
      ? rawAreas.map(a => typeof a === 'object' ? (a.cityName || a.name || '') : a).filter(Boolean)
      : rawAreas ? [rawAreas] : [];

    this.setState({
      // Basic fields — controlled state drives the inputs
      firstName:       u.firstName              || this.state.firstName,
      lastName:        u.lastName               || this.state.lastName,
      phone:           u.phone                  || this.state.phone,
      mobile:          nd.mobile                || this.state.mobile,
      titleorPosition: nd.titleorPosition       || this.state.titleorPosition,
      faxNumber:       nd.faxNumber             || this.state.faxNumber,
      companyName:     nd.companyName           || this.state.companyName,
      whatsapp:        nd.whatsapp              || this.state.whatsapp,
      mlsId:           u.mlsId                  || this.state.mlsId,
      licenseIds:      nd.licenseIds            || this.state.licenseIds,
      userState:       nd.userState             || this.state.userState,
      language:        nd.language              || this.state.language,
      website:         nd.website               || this.state.website,
      profileUrl:      u.profileUrl             || this.state.profileUrl,
      referedByName:   u.referedByName          || this.state.referedByName,
      // Existing fields
      richtTextBiofield: u.userBio          || this.state.richtTextBiofield,
      serviceAreas:      serviceAreas.length ? serviceAreas : this.state.serviceAreas,
      Ziplist:           nd.zipCodes?.length ? nd.zipCodes  : this.state.Ziplist,
      optionsSelected:   Array.isArray(nd.Specialties) && nd.Specialties.length
                           ? nd.Specialties : this.state.optionsSelected,
      experience:        ap.experience     || this.state.experience,
      unique_angle:      ap.unique_angle   || this.state.unique_angle,
      price_range:       ap.price_range    || this.state.price_range,
      client_types:      ap.client_types?.length   ? ap.client_types   : this.state.client_types,
      voice_tone:        ap.voice_tone     || this.state.voice_tone,
      emoji_usage:       ap.emoji_usage    || this.state.emoji_usage,
      opinion_level:     ap.opinion_level  || this.state.opinion_level,
      cta_style:         ap.cta_style      || this.state.cta_style,
      brand_word:        ap.brand_word     || this.state.brand_word,
      platforms:         ap.platforms?.length      ? ap.platforms      : this.state.platforms,
      posting_freq:      ap.posting_freq   || this.state.posting_freq,
      post_length:       ap.post_length    || this.state.post_length,
      content_mix:       ap.content_mix?.length    ? ap.content_mix    : this.state.content_mix,
      hobbies:           ap.hobbies?.length         ? ap.hobbies        : this.state.hobbies,
      why_values:        ap.why_values?.length      ? ap.why_values     : this.state.why_values,
      family_stage:      ap.family_stage   || this.state.family_stage,
      grew_up:           ap.grew_up        || this.state.grew_up,
      origin_story:      ap.origin_story   || this.state.origin_story,
      fun_fact:          ap.fun_fact       || this.state.fun_fact,
      local_love:        ap.local_love     || this.state.local_love,
      great_work_day:    ap.great_work_day || this.state.great_work_day,
      facebook:          sm.facebook       || this.state.facebook,
      instagram:         sm.instagram      || this.state.instagram,
      linkedin:          sm.Linkedin       || this.state.linkedin,
      youtube:           sm.youtube        || this.state.youtube,
      twitter:           sm.twitter        || this.state.twitter,
    });

    // Also update the Ant Design Form instance so initialValue fields re-render
    if (this.formRef?.current) {
      this.formRef.current.setFieldsValue({
        firstName:       u.firstName                  || "",
        lastName:        u.lastName                   || "",
        email:           u.email                      || "",
        phone:           u.phone                      || "",
        mobile:          u.newdata?.mobile            || "",
        titleorPosition: u.newdata?.titleorPosition   || "",
        faxNumber:       u.newdata?.faxNumber         || "",
        companyName:     u.newdata?.companyName       || "",
        whatsapp:        u.newdata?.whatsapp          || "",
        mlsId:           u.mlsId                     || "",
        licenseIds:      u.newdata?.licenseIds        || "",
        userState:       u.newdata?.userState         || "",
        language:        u.newdata?.language          || "",
        website:         u.newdata?.website           || "",
        profileUrl:      u.profileUrl                 || "",
      });
    }
  };

  componentDidUpdate(prevProps) {
    const prev = prevProps.userDetails;
    const next = this.props.userDetails;
    if (!prev || !next) return;
    // Only re-hydrate if the user record actually changed
    if (prev.id === next.id && prev.updatedAt === next.updatedAt) return;
    this.hydrateFromUser(next);
  }

  getAllUsers = async () => {
    try {
      const usersList = await noAuthlist("getUsers");
      const finalUsersList = usersList.data.map(user => ({
        value: user.id,
        label: user.firstName + " " + user.lastName,
      }));
      if (usersList.success) this.setState({ allUsersList: finalUsersList });
    } catch (error) {
      notification["error"]({ message: error.message });
    }
  };

  toggleChip = (field, value, max = 99) => {
    this.setState(prev => {
      const arr = prev[field] || [];
      const has = arr.includes(value);
      if (!has && arr.length >= max) return prev;
      return { [field]: has ? arr.filter(x => x !== value) : [...arr, value] };
    });
  };

  handleZip = (e) => this.setState({ zip: e.target.value });

  handleChange = () => {
    if (this.state.Ziplist.includes(this.state.zip)) {
      notification["error"]({ message: "Duplicate zip code" });
    } else {
      const Ziplist = [...this.state.Ziplist, this.state.zip];
      this.setState({ Ziplist, zip: "" });
    }
  };

  handleDeselect = (value) => {
    const Ziplist = this.state.Ziplist.filter(z => z !== value);
    this.setState({ Ziplist });
  };

  handleServiceAreas = (address) => {
    geocodeByAddress(address.label)
      .then(results => {
        const components = results[0].address_components;
        for (const c of components) {
          if (c.types[0] === "locality") {
            const city = c.long_name;
            if (!this.state.serviceAreas.includes(city)) {
              this.setState({ serviceAreas: [...this.state.serviceAreas, city] });
            }
          }
        }
      })
      .catch(console.error);
  };

  handleZipCode = (address) => {
    const citySearch = address.label.split(",");
    this.setState({ citySearch });
    geocodeByAddress(address.label)
      .then(results => {
        const components = results[0].address_components;
        for (const c of components) {
          if (c.types[0] === "postal_code") {
            this.setState({ zipCode: c.long_name });
          }
        }
      })
      .catch(console.error);
  };

  handleRichtextBio = (bio) => this.setState({ richtTextBiofield: bio });

  handleSpecialties = (value) => {
    this.setState({ optionsSelected: value });
    const { userDetails } = this.props;
    if (value.length === userDetails?.subscriptionPack?.specialites) {
      notification.info({ message: "Please upgrade to add more specialties" });
    }
  };

  handleLink = () => this.setState({ showSubscriptions: true });

  onFinish = (e) => this.updateDetails(e);

  onReferedBySelect = (value, option) => {
    this.setState({ referedById: option.value, referedByName: option.label });
  };

  updateDetails = async (data2) => {
    // Always use context.state for the authoritative user record
    const userDetails = this.props.context?.state?.userDetails || this.props.userDetails || {};

    if (
      userDetails?.userProfile === "B" &&
      this.state.serviceAreas.length === 0
    ) {
      notification["error"]({
        message: "Towns of Interest",
        description: "Please select at least one town",
      });
      return;
    }

    this.setState({ saveDetailsFalse: true });

    const { richtTextBiofield } = this.state;
    const id = userDetails.id;

    data2["profilePicture"] =
      this.props.fileList?.length > 0
        ? this.props.fileList
        : userDetails.profilePicture || "";

    // profileUrl handled in save payload with fallback

    data2["address"] =
      this.state.citySearch.length > 0
        ? this.state.citySearch
        : userDetails.newdata?.companyAddress;

    data2["postalCode"] = this.state.zipCode || "";

    const data = {
      entityData: {
        newdata: {
          zipCodes:        this.state.Ziplist.length         ? this.state.Ziplist         : (userDetails.newdata?.zipCodes        || []),
          whatsapp:        this.state.whatsapp,
          serviceAreas:    this.state.serviceAreas.length ? this.state.serviceAreas : (userDetails.newdata?.serviceAreas || []),
          titleorPosition: this.state.titleorPosition,
          mobile:          this.state.mobile,
          language:        this.state.language,
          faxNumber:       this.state.faxNumber,
          Specialties:     this.state.optionsSelected.length ? this.state.optionsSelected : (userDetails.newdata?.Specialties || []),
          TaxNumber:       data2.TaxNumber       || userDetails.newdata?.TaxNumber || "",
          companyName:     this.state.companyName,
          companyAddress:  this.state.citySearch.length > 0 ? this.state.citySearch : (userDetails.newdata?.companyAddress || ""),
          officeZipCode:   this.state.zipCode    || userDetails.newdata?.officeZipCode || "",
          website:         this.state.website,
          licenseIds:      this.state.licenseIds,
          userState:       this.state.userState,
        },
        email:          this.props.context?.state?.userDetails?.email || userDetails.email || "",
        firstName:      this.state.firstName,
        lastName:       this.state.lastName,
        mlsId:          this.state.mlsId.toUpperCase(),
        licenseIds:     this.state.licenseIds,
        phone:          this.state.phone,
        profilePicture: data2.profilePicture  || userDetails.profilePicture  || "",
        profileUrl:     this.state.profileUrl.replace(/\s+/g, ""),
        userBio:        richtTextBiofield     || userDetails.userBio         || "",
        referedByName:  this.state.referedByName || userDetails.referedByName || "",
        referedById:    this.state.referedById   || userDetails.referedById   || "",
        // Social media
        socialMedia: {
          facebook:  this.state.facebook  || "",
          instagram: this.state.instagram || "",
          Linkedin:  this.state.linkedin  || "",
          youtube:   this.state.youtube   || "",
          twitter:   this.state.twitter   || "",
          website:   data2.website        || "",
        },
        // Agent personality
        agentPersonality: {
          experience:     this.state.experience     || "",
          unique_angle:   this.state.unique_angle   || "",
          client_types:   this.state.client_types   || [],
          price_range:    this.state.price_range     || "",
          voice_tone:     this.state.voice_tone      || "",
          emoji_usage:    this.state.emoji_usage     || "",
          opinion_level:  this.state.opinion_level   || "",
          cta_style:      this.state.cta_style        || "",
          platforms:      this.state.platforms        || [],
          posting_freq:   this.state.posting_freq     || "",
          post_length:    this.state.post_length      || "",
          content_mix:    this.state.content_mix      || [],
          hobbies:        this.state.hobbies          || [],
          why_values:     this.state.why_values       || [],
          family_stage:   this.state.family_stage     || "",
          grew_up:        this.state.grew_up          || "",
          origin_story:   this.state.origin_story     || "",
          fun_fact:       this.state.fun_fact          || "",
          local_love:     this.state.local_love        || "",
          great_work_day: this.state.great_work_day    || "",
          brand_word:     this.state.brand_word        || "",
        },
      },
    };


    if (data.entityData.email && data.entityData.firstName) {
      const updatingUserDetails = await update("users", id, data);

      if (updatingUserDetails.success) {
        this.setState({ saveDetailsFalse: false });
        notification["success"]({
          message: "Profile Updated",
          description: "Your profile details updated successfully",
          duration: 3,
        });
      }
      const userProfileDetails = await getDetails("users", id);
      localStorage.removeItem("userDetails");
      localStorage.setItem("userDetails", JSON.stringify(userProfileDetails.data));
      this.props.context.setUserDetails(userProfileDetails.data);
    } else {
      this.setState({ saveDetailsFalse: false });
    }
  };

  setLoadingfalse = () => this.setState({ dataLoadingFalse: false });

  // ── Render helpers ──────────────────────────────────────────────────────────

  renderChipGroup = (label, stateKey, options, max, tooltip) => (
    <div style={{ marginBottom: "16px" }}>
      <label style={labelStyle}>
        {label}
        {max && <span style={{ color: MUTED, fontWeight: 400, textTransform: "none", marginLeft: "6px" }}>
          (pick up to {max})
        </span>}
      </label>
      <div>
        {options.map(opt => (
          <Tooltip key={opt} title={tooltip ? tooltip[opt] : undefined}>
            <span
              style={chip((this.state[stateKey] || []).includes(opt))}
              onClick={() => this.toggleChip(stateKey, opt, max)}
            >
              {opt}
            </span>
          </Tooltip>
        ))}
      </div>
    </div>
  );

  renderSingleChoice = (label, stateKey, options, tooltips) => (
    <div style={{ marginBottom: "16px" }}>
      <label style={labelStyle}>{label}</label>
      <div>
        {options.map(([val, desc]) => (
          <Tooltip key={val} title={desc}>
            <span
              style={chip(this.state[stateKey] === val)}
              onClick={() => this.setState({ [stateKey]: val })}
            >
              {val}
            </span>
          </Tooltip>
        ))}
      </div>
    </div>
  );

  render() {
    const { saveDetailsFalse, serviceAreas, optionsSelected, showSubscriptions } = this.state;
    // Read from context.state directly so we always get the freshest data,
    // even if the parent component didn't re-render to pass updated props
    const userDetails = this.props.context?.state?.userDetails || this.props.userDetails || {};
    const isAgentOrLender = userDetails?.userProfile === "AG" ||
                            userDetails?.userProfile === "L"  ||
                            userDetails?.userProfile === "V";
    const isBuyerOrSeller = userDetails?.userProfile === "B" ||
                        userDetails?.userProfile === "S";                        

    const opts = SPECIALTIES.map(s => ({ label: s, value: s }));

    return (
      <>
        <Form
          ref={this.formRef}
          initialValues={{ remember: true }}
          onFinish={this.onFinish}
          size="large"
        >
          {/* ── STICKY SAVE BAR ─────────────────────────────────────── */}
          <div style={{
            position: "sticky", top: 0, zIndex: 100,
            background: "#fff", borderBottom: "2px solid #E2E8F0",
            padding: "10px 0", marginBottom: "8px",
            display: "flex", alignItems: "center", justifyContent: "space-between",
          }}>
            <span style={{ fontSize: "13px", color: "#718096", fontWeight: 600 }}>
              Profile Settings
            </span>
            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              {userDetails?.profileUrl && (
                <a
                  href={`/${userDetails.profileUrl}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    fontSize: "13px", color: "#1A2280", fontWeight: 600,
                    textDecoration: "none", border: "1.5px solid #1A2280",
                    borderRadius: "50px", padding: "5px 14px",
                  }}
                >
                  👁 View My Page
                </a>
              )}
              <Button type="primary" htmlType="submit"
                loading={saveDetailsFalse}
                style={{ borderRadius: "50px", fontWeight: 700 }}>
                Save Profile
              </Button>
            </div>
          </div>

          <Spin spinning={saveDetailsFalse}>

            {/* ── BASIC INFO ──────────────────────────────────────────────── */}
            <div style={sectionTitle}>Basic Information</div>
            <Row gutter={[16, 0]}>
              <Col span={11}>
                <div className="label-titles">Referred by</div>
                <Form.Item name="referedBy">
                  <Select
                    showSearch
                    optionFilterProp="children"
                    options={this.state.allUsersList}
                    onSelect={this.onReferedBySelect}
                    placeholder="Referred by"
                    defaultValue={userDetails?.referedByName || ""}
                    filterOption={(input, option) =>
                      option.label.toUpperCase().indexOf(input.toUpperCase()) !== -1
                    }
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={[16, 0]}>
              <Col span={11}>
                <div className="label-titles">First Name</div>
                <Form.Item name="firstName">
                  <Input placeholder="First Name"
                    value={this.state.firstName}
                    onChange={e => this.setState({ firstName: e.target.value })} />
                </Form.Item>

                <div className="label-titles">Phone</div>
                <Form.Item name="phone">
                  <Input
                    placeholder="Enter your phone number"
                    className="input-number-myprofile"
                    value={this.state.phone}
                    onChange={e => this.setState({ phone: e.target.value })} />
                </Form.Item>

                {isAgentOrLender && (
                  <>
                    <div className="label-titles">Mobile</div>
                    <Form.Item name="mobile">
                      <Input className="input-number-myprofile" placeholder="mobile"
                        value={this.state.mobile}
                        onChange={e => this.setState({ mobile: e.target.value })} />
                    </Form.Item>

                    <div className="label-titles">Title or Position</div>
                    <Form.Item name="titleorPosition">
                      <Input placeholder="Enter your title or position"
                        value={this.state.titleorPosition}
                        onChange={e => this.setState({ titleorPosition: e.target.value })} />
                    </Form.Item>

                    <div className="label-titles">Fax Number</div>
                    <Form.Item name="faxNumber">
                      <Input className="input-number-myprofile" placeholder="Fax number"
                        value={this.state.faxNumber}
                        onChange={e => this.setState({ faxNumber: e.target.value })} />
                    </Form.Item>

                    <div className="label-titles">Company Name</div>
                    <Form.Item name="companyName">
                      <Input placeholder="Company name"
                        value={this.state.companyName}
                        onChange={e => this.setState({ companyName: e.target.value })} />
                    </Form.Item>
                  </>
                )}
              </Col>

              <Col offset={1} span={11}>
                <div className="label-titles">Last Name</div>
                <Form.Item name="lastName">
                  <Input placeholder="Last Name"
                    value={this.state.lastName}
                    onChange={e => this.setState({ lastName: e.target.value })} />
                </Form.Item>

                <div className="label-titles">Email</div>
                <Form.Item name="email">
                  <Input readOnly placeholder="email" value={this.state.firstName ? (this.props.context?.state?.userDetails?.email || this.props.userDetails?.email || "") : ""} />
                </Form.Item>

                {isAgentOrLender && (
                  <>
                    <div className="label-titles">WhatsApp</div>
                    <Form.Item name="whatsapp">
                      <Input className="input-number-myprofile"
                        placeholder="WhatsApp with country code"
                        value={this.state.whatsapp}
                        onChange={e => this.setState({ whatsapp: e.target.value })} />
                    </Form.Item>

                    <div className="label-titles">MLS ID</div>
                    <Form.Item name="mlsId">
                      <Input placeholder="MLS ID" style={{ textTransform: "uppercase" }}
                        value={this.state.mlsId}
                        onChange={e => this.setState({ mlsId: e.target.value.toUpperCase() })} />
                    </Form.Item>

                    <div className="label-titles">License IDs (if multiple, separate with commas)</div>
                    <Form.Item name="licenseIds">
                      <Input placeholder="MA-9517648, CT-REB0790561"
                        value={this.state.licenseIds}
                        onChange={e => this.setState({ licenseIds: e.target.value })} />
                    </Form.Item>

                    <div className="label-titles">Add your state</div>
                    <Form.Item name="userState">
                      <Input placeholder="e.g. MA"
                        value={this.state.userState}
                        onChange={e => this.setState({ userState: e.target.value })} />
                    </Form.Item>

                    <div className="label-titles">Languages (comma-separated)</div>
                    <Form.Item name="language">
                      <Input placeholder="English, Spanish, French"
                        value={this.state.language}
                        onChange={e => this.setState({ language: e.target.value })} />
                    </Form.Item>

                    <div className="label-titles">Company Address</div>
                    <Form.Item name="address">
                      <GooglePlacesAutocomplete
                        apiKey={process.env.REACT_APP_MAPS_KEY}
                        autocompletionRequest={{ componentRestrictions: { country: ["us"] } }}
                        selectProps={{
                          defaultInputValue: userDetails?.newdata?.companyAddress || "",
                          placeholder: "Type Company Address",
                          onChange: result => this.handleZipCode(result),
                        }}
                      />
                    </Form.Item>
                  </>
                )}
              </Col>
            </Row>

            {/* Personal URL */}
            {isAgentOrLender && (
              <Row>
                <Col span={23}>
                  <div className="label-titles">Your Personal Page URL</div>
                  <Form.Item name="profileUrl">
                    <Input
                      placeholder="e.g. TracyBarber"
                      addonBefore="myhomebuddha.com/"
                      value={this.state.profileUrl}
                      onChange={e => this.setState({ profileUrl: e.target.value.replace(/\s+/g,"") })} />
                  </Form.Item>
                  <p style={{ fontSize: "12px", color: MUTED, marginTop: "-12px" }}>
                    No spaces. This is your shareable branded link.
                  </p>
                </Col>
              </Row>
            )}

            {/* Website */}
            {isAgentOrLender && (
              <Row>
                <Col span={23}>
                  <div className="label-titles">Website</div>
                  <Form.Item name="website">
                    <Input placeholder="https://www.yourwebsite.com"
                      value={this.state.website}
                      onChange={e => this.setState({ website: e.target.value })} />
                  </Form.Item>
                </Col>
              </Row>
            )}

            {/* Zip codes */}
            {userDetails?.userProfile === "AG" && (
              <Col span={23}>
                <div className="label-titles">
                  Zip codes serviced
                  {userDetails?.subscriptionPack?.zipcodes && (
                    <p style={{ float: "right", marginBottom: 0, color: "#718096" }}>
                      {userDetails.subscriptionPack.zipcodes - this.state.Ziplist.length} left
                    </p>
                  )}
                </div>
                <Form.List name="multiZipCodesList" initialValue={[]}>
                  {(fields, { add, remove }) => (
                    <>
                      <Form.Item>
                        <Input
                          type="number"
                          style={{ width: "75%" }}
                          value={this.state.zip}
                          onChange={this.handleZip}
                        />
                        <Button onClick={() => { add(); this.handleChange(); }}
                              style={{ width: "25%", float: "right", background: "#1890ff", color: "white" }}
                              icon={<PlusOutlined />}
                              disabled={this.state.zip.length === 0}>Add Zipcode</Button>
                      </Form.Item>
                      <Row>
                        {this.state.Ziplist.map((field, index) => (
                          <Form.Item required={false} key={index}>
                            <Input readOnly style={{ width: "70%", marginRight: "-50px" }} value={field}
                              addonAfter={
                                <CloseOutlined onClick={() => { remove(field); this.handleDeselect(field); }}
                                  style={{ color: "red" }} />
                              }
                            />
                          </Form.Item>
                        ))}
                      </Row>
                    </>
                  )}
                </Form.List>
              </Col>
            )}

            {/* Service Areas */}
            <Col span={23}>
              <div className="label-titles">
                {userDetails?.userProfile !== "B"
                  ? "Towns / counties you specialize in"
                  : "Towns of Interest"}
              </div>
              <Form.Item name="serviceAreas">
                <GooglePlacesAutocomplete
                  apiKey={process.env.REACT_APP_MAPS_KEY}
                  autocompletionRequest={{ types: ["(cities)"], componentRestrictions: { country: ["us"] } }}
                  selectProps={{
                    placeholder: "Add a town or city",
                    onChange: result => this.handleServiceAreas(result),
                  }}
                />
                <div style={{ marginTop: "8px" }}>
                  {serviceAreas.map((city, i) => (
                    <Tag key={i} closable
                      onClose={() => this.setState({ serviceAreas: serviceAreas.filter(a => a !== city) })}
                      style={{ marginBottom: "4px", borderRadius: "20px" }}>
                      {city}
                    </Tag>
                  ))}
                </div>
              </Form.Item>
            </Col>

            {/* Specialties */}
            {userDetails?.userProfile === "AG" && (
              <Col span={23}>
                <div className="label-titles">Specialties</div>
                <Select mode="multiple" style={{ width: "100%", marginBottom: "16px" }}
                  placeholder="Select specialties"
                  onChange={this.handleSpecialties}
                  value={this.state.optionsSelected}
                >
                  {SPECIALTIES.map(item => (
                    <Option key={item} value={item}>{item}</Option>
                  ))}
                </Select>
              </Col>
            )}

            {/* Bio */}
            <Col span={23}>
              <div id="About" className="form-titles">About me</div>
              <Form.Item name="userBio" initialValue={userDetails?.userBio || ""}>
                <RichText
                  handleRichtextBio={this.handleRichtextBio}
                  richtTextBiofieldProp={userDetails?.userBio || ""}
                />
              </Form.Item>
            </Col>

            {/* ── MID-PAGE SAVE ───────────────────────────────────────────── */}
            <Row style={{ margin: "8px 0 16px 0" }}>
              <Col span={24} style={{ textAlign: "right" }}>
                <Button type="primary" htmlType="submit" className="btn btn-success"
                  loading={saveDetailsFalse}
                  style={{ borderRadius: "50px", fontWeight: 700 }}>
                  Save Profile
                </Button>
              </Col>
            </Row>

            {/* ── SOCIAL MEDIA ─────────────────────────────────────────────── */}
            {isAgentOrLender && (
              <>
                <div style={sectionTitle}>Social Media</div>
                <Row gutter={[16, 0]}>
                  {[
                    ["Facebook URL", "facebook", "https://www.facebook.com/yourpage"],
                    ["Instagram URL", "instagram", "https://www.instagram.com/yourhandle"],
                    ["LinkedIn URL", "linkedin", "https://www.linkedin.com/in/yourname"],
                    ["YouTube URL", "youtube", "https://www.youtube.com/channel/..."],
                    ["Twitter / X URL", "twitter", "https://twitter.com/yourhandle"],
                  ].map(([label, field, placeholder]) => (
                    <Col span={12} key={field}>
                      <div className="label-titles">{label}</div>
                      <Input
                        value={this.state[field]}
                        onChange={e => this.setState({ [field]: e.target.value })}
                        placeholder={placeholder}
                        style={{ marginBottom: "16px" }}
                      />
                    </Col>
                  ))}
                </Row>
              </>
            )}

            {/* ── YOUR PRACTICE ────────────────────────────────────────────── */}
            {isAgentOrLender && (
              <>
                <div style={sectionTitle}>Your Practice</div>
                <Row gutter={[16, 0]}>
                  <Col span={23}>
                    <div className="label-titles">Years of Experience / Track Record</div>
                    <Input
                      value={this.state.experience}
                      onChange={e => this.setState({ experience: e.target.value })}
                      placeholder="e.g. 15 years, 500+ families helped in Central MA"
                      style={{ marginBottom: "16px" }}
                    />
                  </Col>
                  <Col span={23}>
                    <div className="label-titles">Your Unique Angle</div>
                    <TextArea rows={3}
                      value={this.state.unique_angle}
                      onChange={e => this.setState({ unique_angle: e.target.value })}
                      placeholder="e.g. Former construction manager — I catch what others miss on inspections"
                      style={{ marginBottom: "16px" }}
                    />
                  </Col>
                  <Col span={23}>
                    <div className="label-titles">Price Range</div>
                    <Select
                      value={this.state.price_range || undefined}
                      onChange={v => this.setState({ price_range: v })}
                      placeholder="Select range"
                      style={{ width: "300px", marginBottom: "16px" }}
                      getPopupContainer={t => t.parentNode}
                    >
                      {["Under $300K","$300K-$500K","$500K-$750K","$750K-$1M","$1M-$2M","$2M+","All ranges"].map(r => (
                        <Option key={r} value={r}>{r}</Option>
                      ))}
                    </Select>
                  </Col>
                  <Col span={23}>
                    {this.renderChipGroup("Client Types", "client_types", CLIENT_TYPES)}
                  </Col>
                </Row>
              </>
            )}

            {/* ── YOUR VOICE ───────────────────────────────────────────────── */}
            {isAgentOrLender && (
              <>
                <div style={sectionTitle}>Your Voice & Content Style</div>
                <Row gutter={[16, 0]}>
                  <Col span={23}>
                    {this.renderSingleChoice("Tone", "voice_tone", [
                      ["Professional","Polished, authoritative"],
                      ["Conversational","Warm, approachable"],
                      ["Bold","Confident, direct"],
                      ["Warm","Empathetic, caring"],
                    ])}
                    {this.renderSingleChoice("Emoji Usage", "emoji_usage", [
                      ["Never","Clean, text-only"],
                      ["Sometimes","1-2 when they add meaning"],
                      ["Often","Emojis throughout"],
                    ])}
                    {this.renderSingleChoice("Opinion Level", "opinion_level", [
                      ["Factual","Just the facts"],
                      ["Balanced","Facts with perspective"],
                      ["Opinionated","Strong takes"],
                    ])}
                    {this.renderSingleChoice("Call to Action Style", "cta_style", [
                      ["Soft","Feel free to reach out"],
                      ["Direct","Call me when you're ready"],
                      ["Urgent","Limited inventory — let's talk now"],
                    ])}
                  </Col>
                  <Col span={23}>
                    <div className="label-titles">One Word That Describes Your Brand</div>
                    <Input
                      value={this.state.brand_word}
                      onChange={e => this.setState({ brand_word: e.target.value })}
                      placeholder="e.g. Trusted / Bold / Neighborly / Relentless"
                      style={{ maxWidth: "300px", marginBottom: "16px" }}
                    />
                  </Col>
                  <Col span={23}>
                    {this.renderChipGroup("Platforms", "platforms", [
                      "Instagram","Facebook","LinkedIn","YouTube","TikTok","Email newsletter"
                    ])}
                    {this.renderSingleChoice("Posting Frequency", "posting_freq", [
                      ["Daily",""],["A few times a week",""],["Weekly",""],["A few times a month",""],
                    ])}
                    {this.renderSingleChoice("Post Length", "post_length", [
                      ["Short (1-2 sentences)",""],["Medium (1 paragraph)",""],["Long (storytelling)",""],
                    ])}
                    {this.renderChipGroup("Content Mix", "content_mix", [
                      "Market updates","Listings","Client stories","Local tips","Personal/lifestyle","Educational"
                    ])}
                  </Col>
                </Row>
              </>
            )}

            {/* ── SAVE BEFORE LIFE ────────────────────────────────────────── */}
            {isAgentOrLender && (
              <Row style={{ margin: "8px 0 16px 0" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button type="primary" htmlType="submit" className="btn btn-success"
                    loading={saveDetailsFalse}
                    style={{ borderRadius: "50px", fontWeight: 700 }}>
                    Save Profile
                  </Button>
                </Col>
              </Row>
            )}

            {/* ── YOUR LIFE ────────────────────────────────────────────────── */}
            {isAgentOrLender && (
              <>
                <div style={sectionTitle}>Your Life <span style={{ fontSize: "12px", color: MUTED, fontWeight: 400 }}>(powers AI content personalization)</span></div>
                <Row gutter={[16, 0]}>
                  <Col span={23}>
                    {this.renderChipGroup("Hobbies & Interests", "hobbies", HOBBIES)}
                    {this.renderChipGroup("Why You Do This Work", "why_values", WHY_VALUES, 2)}
                  </Col>
                  {[
                    ["Family / Life Stage", "family_stage", "e.g. Dad of 3, Newlywed, Empty nester"],
                    ["Where You Grew Up", "grew_up", "e.g. Grew up in Worcester, MA"],
                    ["Your Origin Story", "origin_story", "What led you to real estate?"],
                    ["A Fun Fact About You", "fun_fact", "e.g. I've run 12 marathons"],
                    ["What You Love About Your Area", "local_love", "What makes your market special?"],
                    ["What a Great Work Day Looks Like", "great_work_day", "e.g. Morning showing, coffee with clients, closing day"],
                  ].map(([label, field, placeholder]) => (
                    <Col span={23} key={field}>
                      <div className="label-titles">{label}</div>
                      <TextArea rows={2}
                        value={this.state[field]}
                        onChange={e => this.setState({ [field]: e.target.value })}
                        placeholder={placeholder}
                        style={{ marginBottom: "14px" }}
                      />
                    </Col>
                  ))}
                </Row>
              </>
            )}

            {/* ── GROW YOUR NETWORK ────────────────────────────────────────── */}
            {isAgentOrLender && userDetails?.id && (
              <>
                <div style={sectionTitle}>Grow Your Network</div>
                <div style={{
                  background: "linear-gradient(135deg, #0F1560 0%, #1A2280 100%)",
                  borderRadius: "14px", padding: "24px", marginBottom: "16px",
                }}>
                  <div style={{ color: "#FFFFFF", fontWeight: 800, fontSize: "16px", marginBottom: "6px" }}>
                    🔗 Your Personal Invite Link
                  </div>
                  <div style={{ color: "rgba(255,255,255,0.75)", fontSize: "13px", marginBottom: "14px", lineHeight: 1.5 }}>
                    Share this link anywhere — anyone who signs up gets automatically added to your network.
                  </div>

                  <div style={{ display: "flex", gap: "8px", alignItems: "center", marginBottom: "6px" }}>
                    <input
                      readOnly
                      id="agentInviteLink"
                      value={"https://www.myhomebuddha.com/register?ref=" + userDetails.id + "&type=AG&agentName=" + encodeURIComponent((userDetails.firstName || "") + " " + (userDetails.lastName || ""))}
                      style={{
                        flex: 1, padding: "10px 14px", borderRadius: "8px",
                        border: "none", fontSize: "12px", color: "#1A202C",
                        background: "rgba(255,255,255,0.95)", cursor: "text",
                      }}
                    />
                    <button type="button"
                      onClick={() => {
                        const el = document.getElementById("agentInviteLink");
                        el.select(); document.execCommand("copy");
                        this.setState({ inviteLinkCopied: true });
                        setTimeout(() => this.setState({ inviteLinkCopied: false }), 2500);
                      }}
                      style={{
                        background: "#D4921A", color: "#2A1600", border: "none",
                        borderRadius: "8px", padding: "10px 16px", fontWeight: 700,
                        fontSize: "13px", cursor: "pointer", whiteSpace: "nowrap", flexShrink: 0,
                      }}>
                      {this.state.inviteLinkCopied ? "✓ Copied!" : "📋 Copy Link"}
                    </button>
                  </div>
                  <div style={{ color: "rgba(255,255,255,0.45)", fontSize: "11px", marginBottom: "20px" }}>
                    Signups via this link appear in My Network automatically — no manual entry needed
                  </div>

                  <div style={{ color: "#FFD98E", fontWeight: 700, fontSize: "13px", marginBottom: "10px" }}>
                    📱 Ready-to-Post Social Templates
                  </div>
                  {[
                    {
                      label: "👥 Facebook / LinkedIn",
                      key: "cp0",
                      post: [
                        "🏡 Big news — I'm now a My Home Buddha Professional!",
                        "",
                        "If you're thinking about buying, selling, or just want to stay ahead of the market, join my free real estate inner circle.",
                        "",
                        "✅ AI-powered home search",
                        "✅ Personalized market reports",
                        "✅ Off-MLS listings before they go public",
                        "✅ Direct access to me anytime",
                        "",
                        "Create your FREE account here 👇",
                        "https://www.myhomebuddha.com/register?ref=" + (userDetails.id || "") + "&type=AG",
                        "",
                        "#RealEstate #MyHomeBuddha #HomeBuying #LocalExpert",
                      ].join("\n"),
                    },
                    {
                      label: "📸 Instagram Caption",
                      key: "cp1",
                      post: [
                        "Exciting news! 🏡✨",
                        "",
                        "I've joined My Home Buddha — a smarter way to buy, sell & search for homes with AI.",
                        "",
                        "Join my network FREE:",
                        "🤖 AI home reports  🔍 Smart search",
                        "📊 Real-time market data  🏷 Off-market listings",
                        "",
                        "Link in bio OR sign up:",
                        "https://www.myhomebuddha.com/register?ref=" + (userDetails.id || "") + "&type=AG",
                        "",
                        "#HomeSearch #RealEstate #AITools #MyHomeBuddha",
                      ].join("\n"),
                    },
                    {
                      label: "💬 Text / SMS",
                      key: "cp2",
                      post: "Hey! I'm now on My Home Buddha 🏡 — a free AI-powered home platform. Join my network for smart search, market reports & direct access to me: https://www.myhomebuddha.com/register?ref=" + (userDetails.id || "") + "&type=AG",
                    },
                  ].map((t) => (
                    <div key={t.key} style={{
                      background: "rgba(255,255,255,0.07)", borderRadius: "10px",
                      border: "1px solid rgba(255,255,255,0.15)", marginBottom: "8px", overflow: "hidden",
                    }}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 14px", borderBottom: "1px solid rgba(255,255,255,0.1)" }}>
                        <span style={{ color: "rgba(255,255,255,0.85)", fontSize: "12px", fontWeight: 700 }}>{t.label}</span>
                        <button type="button"
                          onClick={() => {
                            navigator.clipboard.writeText(t.post).then(() => {
                              this.setState({ [t.key]: true });
                              setTimeout(() => this.setState({ [t.key]: false }), 2500);
                            }).catch(() => {
                              // fallback for older browsers
                              const ta = document.createElement("textarea");
                              ta.value = t.post;
                              document.body.appendChild(ta);
                              ta.select(); document.execCommand("copy");
                              document.body.removeChild(ta);
                              this.setState({ [t.key]: true });
                              setTimeout(() => this.setState({ [t.key]: false }), 2500);
                            });
                          }}
                          style={{
                            background: "rgba(212,146,26,0.25)", color: "#FFD98E",
                            border: "1px solid rgba(212,146,26,0.4)", borderRadius: "50px",
                            padding: "4px 12px", fontSize: "11px", fontWeight: 700, cursor: "pointer",
                          }}>
                          {this.state[t.key] ? "✓ Copied!" : "Copy Post"}
                        </button>
                      </div>
                      <div style={{ padding: "10px 14px", color: "rgba(255,255,255,0.55)", fontSize: "12px", lineHeight: 1.6, whiteSpace: "pre-line", maxHeight: "80px", overflow: "hidden" }}>
                        {t.post}
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}

            {/* ── HOME BUDDHA PORTAL LINK ──────────────────────────────────── */}
            <div style={sectionTitle}>My Home Portal</div>
            <div style={{
              background: "linear-gradient(135deg, #0F1560 0%, #1A2280 100%)",
              borderRadius: "14px", padding: "20px 24px", marginBottom: "16px",
              display: "flex", alignItems: "center", gap: "16px",
            }}>
              <div style={{ fontSize: "36px" }}>🏡</div>
              <div style={{ flex: 1 }}>
                <div style={{ color: "#FFFFFF", fontWeight: 800, fontSize: "15px", marginBottom: "4px" }}>
                  Home Buddha Portal
                </div>
                <div style={{ color: "rgba(255,255,255,0.72)", fontSize: "13px", lineHeight: 1.5 }}>
                  Your AI-powered home health dashboard. View your home analysis, manage maintenance notes, and chat with your AI home advisor — all in one place.
                </div>
              </div>
              <a
                href="/viewProfile"
                onClick={(e) => {
                  e.preventDefault();
                  const ud = this.props.context?.state?.userDetails || {};
                  const id = ud.id || ud.userid;
                  if (id) window.location.href = "/agent/viewProfile/" + id + "#homebuddha";
                }}
                style={{
                  background: "#D4921A", color: "#2A1600", borderRadius: "50px",
                  padding: "10px 18px", fontWeight: 700, fontSize: "13px",
                  textDecoration: "none", whiteSpace: "nowrap", flexShrink: 0,
                }}>
                Open Portal →
              </a>
            </div>
{isBuyerOrSeller && (
  <div style={sectionTitle}>Home Search Profile</div>
)}
{isBuyerOrSeller && (
  <div style={{
    background: "linear-gradient(135deg, #1A2280, #2A3390)",
    borderRadius: "14px", padding: "20px 24px", marginBottom: "16px",
    display: "flex", alignItems: "center", justifyContent: "space-between",
    flexWrap: "wrap", gap: "12px",
  }}>
    <div>
      <div style={{ color: "#D4921A", fontWeight: 800, fontSize: "14px", marginBottom: "4px" }}>
        Your Buyer Profile
      </div>
      <div style={{ color: "rgba(255,255,255,0.8)", fontSize: "13px" }}>
        Set your home criteria, preferred towns, life addresses (work, school, activities),
        and lifestyle preferences to get AI-powered match scores on every listing.
      </div>
    </div>
    <Button
      onClick={() => this.setState({ showBuyerProfileModal: true })}
      style={{
        background: "#D4921A", border: "none", color: "#2c2416",
        fontWeight: 800, borderRadius: "50px", padding: "0 22px", height: "40px",
        whiteSpace: "nowrap",
      }}
    >
      {userDetails?.buyerProfile ? "Edit Buyer Profile" : "Set Up Buyer Profile"}
    </Button>
  </div>
)}
            {/* ── SAVE ─────────────────────────────────────────────────────── */}
            <Row style={{ marginTop: "24px" }}>
              <Col span={8}>
                <Button type="primary" htmlType="submit" className="btn btn-success">
                  Update Profile
                </Button>
              </Col>
            </Row>

          </Spin>
        </Form>

        <Drawer
          title="Upgrade to Add More"
          placement="bottom" width="100%" height="100%"
          mask closable getContainer={false}
          visible={showSubscriptions}
          onClose={() => this.setState({ showSubscriptions: false })}
          headerStyle={{ textAlign: "center" }}
        >
          <Row>
            <Col span={24}>
              <Subscriptions setLoadingfalse={this.setLoadingfalse} />
            </Col>
          </Row>
        </Drawer>
        {this.state.showBuyerProfileModal && (
          <BuyerProfileModal
            userDetails={userDetails}
            onComplete={() => {
              this.setState({ showBuyerProfileModal: false });
              this.refreshFromApi();
            }}
            onDismiss={() => this.setState({ showBuyerProfileModal: false })}
          />
        )}
      </>
    );
  }
}

export default withAppContext(withRouter(ProfileForm));
